/* ─────────────────────────────────────────────────────────
   PEAKVIEW · GLOBAL BEHAVIOURS
   v1.0
   ───────────────────────────────────────────────────────── */
(function(){
  'use strict';

  // ───── Reveal-on-scroll
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('.pv-reveal, .pv-stagger').forEach(function(el){
      io.observe(el);
    });
  } else {
    // Fallback: just show everything
    document.querySelectorAll('.pv-reveal, .pv-stagger').forEach(function(el){
      el.classList.add('in');
    });
  }

  // ───── Auto-reveal hero on load
  window.addEventListener('load', function(){
    var hero = document.querySelector('.pv-hero__content');
    if (hero) hero.classList.add('in');
  });

  // ───── Smooth anchor scrolling with offset
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if (id.length <= 1) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.offsetTop - 20, behavior: 'smooth' });
    });
  });

  // ───── Waitlist form (Phase 1: optimistic UX, no real submission yet)
  document.querySelectorAll('.pv-access__form').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('button');
      if (!btn) return;
      var orig = btn.textContent;
      btn.textContent = 'Confirmed';
      btn.disabled = true;
      // TODO Phase 2: wire to Klaviyo / Shopify customer create
      setTimeout(function(){
        btn.textContent = orig;
        btn.disabled = false;
        form.reset();
      }, 4000);
    });
  });

})();
